
import React, { Component } from 'react';
import { NotificationManager } from 'react-notifications';

import { AxiosResponse } from 'axios';

import { Message, MessageProps, Typing } from '../../components';
import { BOT_NAME } from '../../constants';
import {
  delay,
  generateUniqueId,
  getMessagesFromText,
  shuffle
} from '../../helpers/utils';
import { sendMessage } from '../../services/chatbot';
import Leader from './Leader';
import Steps, { Item } from './Steps';

interface Props {
  onResult: (message: AxiosResponse[]) => void;
}

interface State {
  isTyping: boolean;
  leader: boolean,
  messages: MessageProps[];
  questions: string[];
  steps: Item[];
}

export default class VocationalTest extends Component<Props, State> {
  state: Readonly<State> = {
    isTyping: false,
    leader: false,
    messages: [],
    questions: [],
    steps: []
  }

  async componentDidMount(): Promise<void> {
    try {
      this.setState({ isTyping: true });
      const response = await sendMessage('');
      const { generic } = response.data.output;
      generic.forEach(async ({ response_type, text }) => {
        if (response_type === 'text') {
          const botMessages = getMessagesFromText(text);
          for (const [botMessage, messageDelay] of botMessages) {
            this.setState({ isTyping: true });
            await delay(messageDelay);
            this.setState((prevState: State) => ({
              isTyping: false,
              messages: [
                ...prevState.messages,
                botMessage
              ]
            }));
          }
          this.setState({ leader: true });
        }
      });
    } catch (error) {
      NotificationManager.error(`Não foi possível comunicar-se com o ${BOT_NAME} no momento, tente novamente mais tarde.`);
      console.log(error);
    }
  }

  handleResult = (message: AxiosResponse[]): void => {
    const { onResult } = this.props;
    onResult(message);
  }

  loadVocationalTest = async (): Promise<void> => {
    try {
      this.setState({ isTyping: true, leader: false, messages: [] });
      const questions: string[] = [];
      const response = await sendMessage('teste vocacional');
      const { generic } = response.data.output;
      generic.forEach(async ({
        options,
        response_type,
        text,
        title
      }) => {
        if (response_type === 'text') {
          const botMessages = getMessagesFromText(text);
          for (const [botMessage, messageDelay] of botMessages) {
            this.setState({ isTyping: true });
            await delay(messageDelay);
            this.setState((prevState: State) => ({
              isTyping: false,
              messages: [
                ...prevState.messages,
                botMessage
              ]
            }));
          }
          this.setState({ questions });
        } else if (response_type === 'option') {
          const temp: any = {};
          options.forEach(({ label }) => {
            const previousQuestions = temp[title];
            temp[title] = previousQuestions ? [...previousQuestions, label] : [label];
          });
          questions.push(temp);
        }
      });
    } catch (error) {
      NotificationManager.error('Não foi possível carregar o teste vocacional no momento, tente novamante mais tarde.');
      console.log(error);
    }
  }

  renderVocationalTest = (): JSX.Element | null => {
    let { questions } = this.state;
    const { steps } = this.state;
    if (questions.length >= 1 && steps.length === 0) {
      const items: Item[] = [];
      // Embaralha Grupo de Perguntas
      questions = [...shuffle(questions)];
      questions.forEach((group, index) => {
        const groupName = Object.keys(group)[0];
        // Embaralha as Perguntas
        const questionShuffled = shuffle(questions[index][groupName]);

        questionShuffled.forEach((q) => {
          items.push({
            questionGroup: groupName,
            questionTitle: q,
            questionValue: ''
          });
        });
      });

      this.setState({ steps: items });
    } else if (steps.length >= 1) {
      return (
        <Message
          date={new Date()}
          fullWidth
          id={generateUniqueId()}
          name={BOT_NAME}
          owner="bot"
          text={<Steps items={steps} onResult={this.handleResult} />
          }
        />
      );
    }

    return null;
  }

  render(): JSX.Element {
    const { isTyping, leader, messages } = this.state;

    return (
      <>
        {
          messages.map(({
            date,
            id,
            name,
            owner,
            text
          }) => (
            <Message
              date={date}
              id={id}
              key={id}
              name={name}
              owner={owner}
              text={text}
            />
          ))
        }
        {
          leader && (
            <Leader onResponded={this.loadVocationalTest} />
          )
        }
        {
          this.renderVocationalTest()
        }
        {
          isTyping && (
            <Typing name={BOT_NAME} />
          )
        }
      </>
    );
  }
}
